<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" custom-class="regNo-dialog" top="15vh" :fullscreen="isExpand" :show-close="false" :before-close="handleClose" :close-on-click-modal="false" :close-on-press-escape="false">
      <template slot="title">
        <div class="default-dialog-title-box">
          <span>选择产品注册证/备案凭证</span>
          <span class="icon-box">
            <img :src="!isExpand ? expandSvg : collapseSvg" @click="isExpand = !isExpand">
            <i class="el-icon-close" @click="handleClose"></i>
          </span>
        </div>
      </template>
      <div class="content">
        <div class="search-box">
          <el-input v-model.trim="search" placeholder="请输入备案凭证号" clearable class="input"></el-input>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
        </div>
        <el-descriptions :colon="false" :column="2" size="medium" labelClassName="descriptionsLabel" contentClassName="descriptionsValue">
          <el-descriptions-item label="医疗器械分类" :span="2">{{ info.medicalPathName || '--' }}</el-descriptions-item>
          <el-descriptions-item label="注册证号/备案凭证号">{{ info.registrationCode || '--' }}</el-descriptions-item>
          <el-descriptions-item label="注册人/备案人/代理人">{{ info.registrantName || '--' }}</el-descriptions-item>
          <el-descriptions-item label="批准备案日期">{{ info.approvalDate ? formatDate(info.approvalDate) : '--' }}</el-descriptions-item>
          <el-descriptions-item label="有效期至">{{ info.effectiveDate ? formatDate(info.effectiveDate) : '--' }}</el-descriptions-item>
          <el-descriptions-item label="管理类别">{{ getCategoryLabel(info.category) }}</el-descriptions-item>
          <el-descriptions-item label="厂商名称">{{ info.manufacturerName || '--' }}</el-descriptions-item>
          <el-descriptions-item label="厂商地区" :span="2">{{ `${info.originProvinceName || ''}${info.originCityName || ''}${info.originAreaName || ''}` || '--' }}</el-descriptions-item>
          <el-descriptions-item label="产品注册证/备案凭证图片" :span="2">
            <template v-if="info.id">
              <div v-if="info.annexList && info.annexList.length">
                <el-image
                  v-for="(annex, i) in info.annexList"
                  :key="'licence-'+i"
                  :src="annex.url"
                  :preview-src-list="info.annexList.map(annex => annex.url)"
                  style="width: 88px; height: 88px; margin-right: 10px; margin-bottom: 10px;">
                </el-image>
              </div>
              <template v-else>
                <Upload
                  v-model.trim="imagesList"
                  @success="handleFileLists"
                  accept="image/png,image/jpeg,image/jpg"
                  :maxSize="10"
                  size="small"
                  :tip="false"
                  :limit="10"
                >
                </Upload>
                <el-button v-if="imagesList.length" @click="handleUploadImage" type="primary" style="margin: 10px 0;">上传凭证图片</el-button>
                <div class="tip-upload">支持上传jpg、jpeg、png格式的文件，文件大小不得超过10M，最多上传 10 张</div>
              </template>
            </template>
            <div v-else>--</div>
          </el-descriptions-item>
        </el-descriptions>
        <!-- <div v-else style="text-align: center;">
          <Empty text="未查询到凭证" :height="150" style="padding-top: 30px;" />
          <el-button type="primary" @click="handleAdd">去手动新增</el-button>
        </div> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button :disabled="!info.id" type="primary" @click="handleSure">保存</el-button>
      </span>
    </el-dialog>

    <!-- <CreateRegisterNoDialog ref="createRegisterNoDialogRef" /> -->
  </div>
</template>
<script>
// import Empty from '@/components/empty.vue';
// import CreateRegisterNoDialog from './createRegisterNoDialog.vue';
import * as Moment from 'dayjs';
import { categoryList } from '@/enums/managerCategoryEnum';
import { registerProductDetail, updateRegisterProduct } from '@/api/registerNo';
export default {
  components: {
    Upload: () => import('@/components/common/upload'),
    // Empty,
    // CreateRegisterNoDialog,
  },
  watch: {
    dialogVisible (v) {
      if (!v) {
        this.search = '';
        this.imagesList = [];
        this.info = this.$options.data().info;
      }
    },
  },
  data () {
    return {
      isExpand: false,
      dialogVisible: false,
      expandSvg: require('@/assets/ic_expand.svg'),
      collapseSvg: require('@/assets/ic_collapse.svg'),
      search: '',
      info: {},
      imagesList: [],
    };
  },
  methods: {
    // handleAdd () {
    //   this.$refs.createRegisterNoDialogRef.dialogVisible = true;
    // },
    formatDate (text, format = 'YYYY-MM-DD') {
      const day = text ? Moment(text * 1).format(format) : '/';
      return day === '9999-12-31' ? '永久' : day;
    },
    getCategoryLabel (v) {
      return categoryList.find(item => item.value === v)?.label || '--';
    },
    handleFileLists (file) {
      this.imagesList.push({
        name: file.name,
        url: file.url,
      });
    },
    async handleUploadImage () {
      const approvalDate = new Date(this.info.approvalDate).getTime();
      const effectiveDate = new Date(this.info.effectiveDate).getTime();
      const params = {
        ...this.info,
        approvalDate,
        effectiveDate,
        annexList: this.imagesList,
      };
      const res = await updateRegisterProduct(params);
      if (res.heads.code === 200) {
        this.$message.success('上传成功！');
        this.handleSearch();
        this.imagesList = [];
      }
    },
    async handleSearch () {
      if (!this.search) {
        this.$message.warning('请输入备案凭证号搜索');
        return;
      }
      const { body } = await registerProductDetail({ registrationCode: this.search });
      if (!body) {
        this.$message.warning('未查询到相关信息');
      }
      this.info = body || {};
    },
    handleClose () {
      this.dialogVisible = false;
    },
    handleSure () {
      this.$emit('select', this.info);
      this.handleClose();
    },
  },
};
</script>
<style lang="scss" scoped>
.regNo-dialog {
  /deep/ .el-dialog__header {
    padding: 16px 20px;
  }
  .search-box {
    padding: 5px 15px 15px;
    .input {
      width: 300px;
      margin-right: 20px;
    }
  }
  .tip-upload {
    font-weight: 400;
    font-size: 14px;
    color: #929AA6;
  }
}
/deep/ .descriptionsLabel {
  width: 100px;
  text-align: right;
  display: inline-block;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #929aa6;
  letter-spacing: 0;
  text-align: right;
  line-height: 20px;
}
/deep/ .descriptionsValue {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #1f2733;
  letter-spacing: 0;
  text-align: left;
  line-height: 20px;
  display: flex;
  flex-direction: column;
}
</style>
